module.exports = __webpack_public_path__ + "img/franchising_why_1.d4257fae.svg";